import React from "react";
import { SkeletonTheme } from "react-loading-skeleton";

export const CHAT_SKELETON_BASE_COLOR = "#E8ECF1";
export const CHAT_SKELETON_HIGHLIGHT_COLOR = "#F5F7FA";

export default function ChatSkeletonTheme({ children }) {
    return (
        <SkeletonTheme
            baseColor={CHAT_SKELETON_BASE_COLOR}
            highlightColor={CHAT_SKELETON_HIGHLIGHT_COLOR}
            duration={1.4}
        >
            {children}
        </SkeletonTheme>
    );
}
